import cancelledIcon from "assets/images/Cancelled_Icon.svg";
import completedIcon from "assets/images/Check_Icon.svg";
import paritalIcon from "assets/images/Partially_Icon.svg";
import pendingIcon from "assets/images/Pending_Icon.svg";
import React from "react";

const CDN_FLAGS_URL = 'https://cdn.paylix.gg/static/flags/';

const PAYMENT_ICONS = {

      ATOM: "https://cdn.paylix.gg/static/gateways/new/atom.svg",
      DOGE: "https://cdn.paylix.gg/static/gateways/new/doge.svg",
      FLOW: "https://cdn.paylix.gg/static/gateways/new/flow.svg",

      PAYPAL: "https://cdn.paylix.gg/static/gateways/new/paypal.svg",
      NANO: "https://cdn.paylix.gg/static/gateways/new/nano.svg",
      BITCOIN: "https://cdn.paylix.gg/static/gateways/new/bitcoin.svg",
      LITECOIN: "https://cdn.paylix.gg/static/gateways/new/litecoin.svg",
      TRON: "https://cdn.paylix.gg/static/gateways/new/tron.svg",
      ETHEREUM: "https://cdn.paylix.gg/static/gateways/new/ethereum.svg",
      CONCORDIUM: "https://cdn.paylix.gg/static/gateways/new/concordium.svg",
      BINANCE_COIN: "https://cdn.paylix.gg/static/gateways/new/binance-coin.svg",
      CRONOS: "https://cdn.paylix.gg/static/gateways/new/cronos.svg",
      USDC: "https://cdn.paylix.gg/static/gateways/new/usdc.svg",
      "USDC:BEP20": "https://cdn.paylix.gg/static/gateways/new/usdc.svg",
      "USDC:ERC20": "https://cdn.paylix.gg/static/gateways/new/usdc.svg",
      "USDC:MATIC": "https://cdn.paylix.gg/static/gateways/new/usdc.svg",
      "USDC_NATIVE": "https://cdn.paylix.gg/static/gateways/new/usdc.svg",
      "USDC_NATIVE:MATIC": "https://cdn.paylix.gg/static/gateways/new/usdc.svg",
      USDT: "https://cdn.paylix.gg/static/gateways/new/usdt.svg",
      "USDT:BEP20": "https://cdn.paylix.gg/static/gateways/new/usdt.svg",
      "USDT:ERC20": "https://cdn.paylix.gg/static/gateways/new/usdt.svg",
      "USDT:TRC20": "https://cdn.paylix.gg/static/gateways/new/usdt.svg",
      "USDT:MATIC": "https://cdn.paylix.gg/static/gateways/new/usdt.svg",


      DAI: "https://cdn.paylix.gg/static/gateways/new/dai.svg",
      "DAI:BEP20": "https://cdn.paylix.gg/static/gateways/new/dai.svg",
      "DAI:ERC20": "https://cdn.paylix.gg/static/gateways/new/dai.svg",
      "DAI:MATIC": "https://cdn.paylix.gg/static/gateways/new/dai.svg",

      SHIB: "https://cdn.paylix.gg/static/gateways/new/shib.svg",
      "SHIB:BEP20": "https://cdn.paylix.gg/static/gateways/new/shib.svg",
      "SHIB:ERC20": "https://cdn.paylix.gg/static/gateways/new/shib.svg",
      "SHIB:MATIC": "https://cdn.paylix.gg/static/gateways/new/shib.svg",

      APE: "https://cdn.paylix.gg/static/gateways/new/ape.svg",
      "APE:ERC20": "https://cdn.paylix.gg/static/gateways/new/ape.svg",

      PEPE: "https://cdn.paylix.gg/static/gateways/new/pepe.svg",
      "PEPE:ERC20": "https://cdn.paylix.gg/static/gateways/new/pepe.svg",


      WETH: "https://cdn.paylix.gg/static/gateways/new/weth.svg",
      "WETH:ERC20": "https://cdn.paylix.gg/static/gateways/new/weth.svg",
      "WETH:MATIC": "https://cdn.paylix.gg/static/gateways/new/weth.svg",


      PLZ: "https://cdn.paylix.gg/static/gateways/new/plz.svg",
      "PLZ:TRC20": "https://cdn.paylix.gg/static/gateways/new/plz.svg",
      "PLZ:BEP20": "https://cdn.paylix.gg/static/gateways/new/plz.svg",

      POLYGON: "https://cdn.paylix.gg/static/gateways/new/polygon.svg",

      BITCOIN_CASH: "https://cdn.paylix.gg/static/gateways/new/bitcoin-cash.svg",
      MONERO: "https://cdn.paylix.gg/static/gateways/new/monero.svg",
      BITCOIN_LN: "https://cdn.paylix.gg/static/gateways/new/bitcoin-ln.svg",
      BINANCE: "https://cdn.paylix.gg/static/gateways/new/binance.svg",
      SKRILL: "https://cdn.paylix.gg/static/gateways/new/skrill.svg",
      PERFECT_MONEY: "https://cdn.paylix.gg/static/gateways/new/perfect-money.svg",
      CASH_APP: "https://cdn.paylix.gg/static/gateways/new/cashapp.svg",
      STRIPE: "https://cdn.paylix.gg/static/gateways/new/stripe.svg",
      SOLANA: "https://cdn.paylix.gg/static/gateways/new/solana.svg",
      RIPPLE: "https://cdn.paylix.gg/static/gateways/new/ripple.svg",

      CARD: "https://cdn.paylix.gg/static/gateways/credit-card.png",

      PAYPAL_EXTRA: {
        BLIK: "https://cdn.paylix.gg/static/gateways/blik.svg",
        EPS: "https://cdn.paylix.gg/static/gateways/eps.png",
        GIROPAY: "https://cdn.paylix.gg/static/gateways/giropay.svg",
        IDEAL: "https://cdn.paylix.gg/static/gateways/ideal.png",
        MERCADOPAGO: "https://cdn.paylix.gg/static/gateways/mercado-pago.png",
        MYBANK: "https://cdn.paylix.gg/static/gateways/mybank.png",
        PAYLATER: "https://cdn.paylix.gg/static/gateways/paylater.jpg",
        PRZELEWY24: "https://cdn.paylix.gg/static/gateways/przelewy24.png",
        SEPA: "https://cdn.paylix.gg/static/gateways/sepa.png",
        SOFORT: "https://cdn.paylix.gg/static/gateways/sofort.png",
        VENMO: "https://cdn.paylix.gg/static/gateways/venmo.png",
        BANCONTACT: "https://cdn.paylix.gg/static/gateways/bancontact.png",
        TRUSTLY: "https://cdn.paylix.gg/static/gateways/trustly.png",
      },

      STRIPE_EXTRA: {
        AFTERPAY_CLEARPAY: "https://cdn.paylix.gg/static/gateways/afterpay.png",
        ALIPAY: "https://cdn.paylix.gg/static/gateways/alipay.png",
        BANCONTACT: "https://cdn.paylix.gg/static/gateways/bancontact.png",
        AU_BECS_DEBIT: "https://cdn.paylix.gg/static/gateways/becs.png",
        BOLETO: "https://cdn.paylix.gg/static/gateways/boleto.png",
        EPS: "https://cdn.paylix.gg/static/gateways/eps.png",
        FPX: "https://cdn.paylix.gg/static/gateways/fpx.jpeg",
        GIROPAY: "https://cdn.paylix.gg/static/gateways/giropay.svg",
        GRABPAY: "https://cdn.paylix.gg/static/gateways/grabpay.jpeg",
        IDEAL: "https://cdn.paylix.gg/static/gateways/ideal.png",
        KLARNA: "https://cdn.paylix.gg/static/gateways/klarna.jpeg",
        OXXO: "https://cdn.paylix.gg/static/gateways/oxxo.png",
        PRZELEWY24: "https://cdn.paylix.gg/static/gateways/przelewy24.png",
        SEPA: "https://cdn.paylix.gg/static/gateways/sepa.png",
        SOFORT: "https://cdn.paylix.gg/static/gateways/sofort.png",
        WECHAT_PAY: "https://cdn.paylix.gg/static/gateways/wechat.png",
        PROMPTPAY: "https://cdn.paylix.gg/static/gateways/wechat.png",
        CASH_APP: "https://cdn.paylix.gg/static/gateways/new/cashapp.svg",
      },
    };


export default {

  RECAPTCHA: '6LfO0QwrAAAAAMc2H6SCObbH_yruosPSkcjk-ZYM',
  CLOUD_FIRE_ID: 'VU2Gexkve1SGQTbghAvrTg',

  EU_LIST: ["AT", "BG", "BE", "EL", "LT", "PT", "ES", "LU", "RO", "CZ", "FR", "HU", "SI", "DK", "HR", "MT", "SK", "DE", "IT", "NL", "FI", "EE", "CY", "SE", "IE", "LV", "PL"],
  COUNTRIES: [
    { label: 'Afghanistan', phone: '+93', value: 'AF', currency: 'AFN' },
    { label: 'Albania', phone: '+355', value: 'AL', currency: 'ALL' },
    { label: 'Algeria', phone: '+213', value: 'DZ', currency: 'DZD' },
    { label: 'American Samoa', phone: '+1684', value: 'AS', currency: 'USD' },
    { label: 'Andorra', phone: '+376', value: 'AD', currency: 'EUR' },
    { label: 'Angola', phone: '+244', value: 'AO', currency: 'AOA' },
    { label: 'Anguilla', phone: '+1264', value: 'AI', currency: 'XCD' },
    { label: 'Antarctica', phone: '+672', value: 'AQ', currency: 'None' },
    { label: 'Antigua and Barbuda', phone: '+1268', value: 'AG', currency: 'XCD' },
    { label: 'Argentina', phone: '+54', value: 'AR', currency: 'ARS' },
    { label: 'Armenia', phone: '+374', value: 'AM', currency: 'AMD' },
    { label: 'Aruba', phone: '+297', value: 'AW', currency: 'AWG' },
    { label: 'Australia', phone: '+61', value: 'AU', currency: 'AUD' },
    { label: 'Austria', phone: '+43', value: 'AT', currency: 'EUR' },
    { label: 'Azerbaijan', phone: '+994', value: 'AZ', currency: 'AZN' },
    { label: 'Bahamas', phone: '+1242', value: 'BS', currency: 'BSD' },
    { label: 'Bahrain', phone: '+973', value: 'BH', currency: 'BHD' },
    { label: 'Bangladesh', phone: '+880', value: 'BD', currency: 'BDT' },
    { label: 'Barbados', phone: '+1246', value: 'BB', currency: 'BBD' },
    { label: 'Belarus', phone: '+375', value: 'BY', currency: 'BYN' },
    { label: 'Belgium', phone: '+32', value: 'BE', currency: 'EUR' },
    { label: 'Belize', phone: '+501', value: 'BZ', currency: 'BZD' },
    { label: 'Benin', phone: '+229', value: 'BJ', currency: 'XOF' },
    { label: 'Bermuda', phone: '+1441', value: 'BM', currency: 'BMD' },
    { label: 'Bhutan', phone: '+975', value: 'BT', currency: 'BTN' },
    { label: 'Bolivia', phone: '+591', value: 'BO', currency: 'BOB' },
    { label: 'Bonaire', phone: '+5997', value: 'BQ', currency: 'USD' },
    { label: 'Bosnia and Herzegovina', phone: '+387', value: 'BA', currency: 'BAM' },
    { label: 'Botswana', phone: '+267', value: 'BW', currency: 'BWP' },
    { label: 'Bouvet Island', phone: '+47', value: 'BV', currency: 'NOK' },
    { label: 'Brazil', phone: '+55', value: 'BR', currency: 'BRL' },
    { label: 'British Indian Ocean Territory', phone: '+246', value: 'IO', currency: 'USD' },
    { label: 'British Virgin Islands', phone: '+1284', value: 'VG', currency: 'USD' },
    { label: 'Brunei', phone: '+673', value: 'BN', currency: 'BND' },
    { label: 'Bulgaria', phone: '+359', value: 'BG', currency: 'BGN' },
    { label: 'Burkina Faso', phone: '+226', value: 'BF', currency: 'XOF' },
    { label: 'Burundi', phone: '+257', value: 'BI', currency: 'BIF' },
    { label: 'Cambodia', phone: '+855', value: 'KH', currency: 'KHR' },
    { label: 'Cameroon', phone: '+237', value: 'CM', currency: 'XAF' },
    { label: 'Canada', phone: '+1', value: 'CA', currency: 'CAD' },
    { label: 'Cape Verde', phone: '+238', value: 'CV', currency: 'CVE' },
    { label: 'Cayman Islands', phone: '+1345', value: 'KY', currency: 'KYD' },
    { label: 'Central African Republic', phone: '+236', value: 'CF', currency: 'XAF' },
    { label: 'Chad', phone: '+235', value: 'TD', currency: 'XAF' },
    { label: 'Chile', phone: '+56', value: 'CL', currency: 'CLP' },
    { label: 'China', phone: '+86', value: 'CN', currency: 'CNY' },
    { label: 'Christmas Island', phone: '+61', value: 'CX', currency: 'AUD' },
    { label: 'Cocos [Keeling] Islands', phone: '+61', value: 'CC', currency: 'AUD' },
    { label: 'Colombia', phone: '+57', value: 'CO', currency: 'COP' },
    { label: 'Comoros', phone: '+269', value: 'KM', currency: 'KMF' },
    { label: 'Cook Islands', phone: '+682', value: 'CK', currency: 'NZD' },
    { label: 'Costa Rica', phone: '+506', value: 'CR', currency: 'CRC' },
    { label: 'Croatia', phone: '+385', value: 'HR', currency: 'HRK' },
    { label: 'Cuba', phone: '+53', value: 'CU', currency: 'CUP' },
    { label: 'Curacao', phone: '+5999', value: 'CW', currency: 'ANG' },
    { label: 'Cyprus', phone: '+357', value: 'CY', currency: 'EUR' },
    { label: 'Czech Republic', phone: '+420', value: 'CZ', currency: 'CZK' },
    { label: 'Democratic Republic of the Congo', phone: '+243', value: 'CD', currency: 'CDF' },
    { label: 'Denmark', phone: '+45', value: 'DK', currency: 'DKK' },
    { label: 'Djibouti', phone: '+253', value: 'DJ', currency: 'DJF' },
    { label: 'Dominica', phone: '+1767', value: 'DM', currency: 'XCD' },
    { label: 'Dominican Republic', phone: '+1809,1829,1849', value: 'DO', currency: 'DOP' },
    { label: 'East Timor', phone: '+670', value: 'TL', currency: 'USD' },
    { label: 'Ecuador', phone: '+593', value: 'EC', currency: 'USD' },
    { label: 'Egypt', phone: '+20', value: 'EG', currency: 'EGP' },
    { label: 'El Salvador', phone: '+503', value: 'SV', currency: 'USD' },
    { label: 'Equatorial Guinea', phone: '+240', value: 'GQ', currency: 'XAF' },
    { label: 'Eritrea', phone: '+291', value: 'ER', currency: 'ERN' },
    { label: 'Estonia', phone: '+372', value: 'EE', currency: 'EUR' },
    { label: 'Ethiopia', phone: '+251', value: 'ET', currency: 'ETB' },
    { label: 'Falkland Islands', phone: '+500', value: 'FK', currency: 'FKP' },
    { label: 'Faroe Islands', phone: '+298', value: 'FO', currency: 'DKK' },
    { label: 'Fiji', phone: '+679', value: 'FJ', currency: 'FJD' },
    { label: 'Finland', phone: '+358', value: 'FI', currency: 'EUR' },
    { label: 'France', phone: '+33', value: 'FR', currency: 'EUR' },
    { label: 'French Guiana', phone: '+594', value: 'GF', currency: 'EUR' },
    { label: 'French Polynesia', phone: '+689', value: 'PF', currency: 'XPF' },
    { label: 'French Southern Territories', phone: '+262', value: 'TF', currency: 'EUR' },
    { label: 'Gabon', phone: '+241', value: 'GA', currency: 'XAF' },
    { label: 'Gambia', phone: '+220', value: 'GM', currency: 'GMD' },
    { label: 'Georgia', phone: '+995', value: 'GE', currency: 'GEL' },
    { label: 'Germany', phone: '+49', value: 'DE', currency: 'EUR' },
    { label: 'Ghana', phone: '+233', value: 'GH', currency: 'GHS' },
    { label: 'Gibraltar', phone: '+350', value: 'GI', currency: 'GIP' },
    { label: 'Greece', phone: '+30', value: 'GR', currency: 'EUR' },
    { label: 'Greenland', phone: '+299', value: 'GL', currency: 'DKK' },
    { label: 'Grenada', phone: '+1473', value: 'GD', currency: 'XCD' },
    { label: 'Guadeloupe', phone: '+590', value: 'GP', currency: 'EUR' },
    { label: 'Guam', phone: '+1671', value: 'GU', currency: 'USD' },
    { label: 'Guatemala', phone: '+502', value: 'GT', currency: 'GTQ' },
    { label: 'Guernsey', phone: '+44', value: 'GG', currency: 'GBP' },
    { label: 'Guinea', phone: '+224', value: 'GN', currency: 'GNF' },
    { label: 'Guinea-Bissau', phone: '+245', value: 'GW', currency: 'XOF' },
    { label: 'Guyana', phone: '+592', value: 'GY', currency: 'GYD' },
    { label: 'Haiti', phone: '+509', value: 'HT', currency: 'HTG' },
    { label: 'Heard Island and McDonald Islands', phone: '+61', value: 'HM', currency: 'AUD' },
    { label: 'Honduras', phone: '+504', value: 'HN', currency: 'HNL' },
    { label: 'Hong Kong', phone: '+852', value: 'HK', currency: 'HKD' },
    { label: 'Hungary', phone: '+36', value: 'HU', currency: 'HUF' },
    { label: 'Iceland', phone: '+354', value: 'IS', currency: 'ISK' },
    { label: 'India', phone: '+91', value: 'IN', currency: 'INR' },
    { label: 'Indonesia', phone: '+62', value: 'ID', currency: 'IDR' },
    { label: 'Iran', phone: '+98', value: 'IR', currency: 'IRR' },
    { label: 'Iraq', phone: '+964', value: 'IQ', currency: 'IQD' },
    { label: 'Ireland', phone: '+353', value: 'IE', currency: 'EUR' },
    { label: 'Isle of Man', phone: '+44', value: 'IM', currency: 'GBP' },
    { label: 'Israel', phone: '+972', value: 'IL', currency: 'ILS' },
    { label: 'Italy', phone: '+39', value: 'IT', currency: 'EUR' },
    { label: 'Ivory Coast', phone: '+225', value: 'CI', currency: 'XOF' },
    { label: 'Jamaica', phone: '+1876', value: 'JM', currency: 'JMD' },
    { label: 'Japan', phone: '+81', value: 'JP', currency: 'JPY' },
    { label: 'Jersey', phone: '+44', value: 'JE', currency: 'GBP' },
    { label: 'Jordan', phone: '+962', value: 'JO', currency: 'JOD' },
    { label: 'Kazakhstan', phone: '+76,77', value: 'KZ', currency: 'KZT' },
    { label: 'Kenya', phone: '+254', value: 'KE', currency: 'KES' },
    { label: 'Kiribati', phone: '+686', value: 'KI', currency: 'AUD' },
    { label: 'Kosovo', phone: '+377,381,383,386', value: 'XK', currency: 'EUR' },
    { label: 'Kuwait', phone: '+965', value: 'KW', currency: 'KWD' },
    { label: 'Kyrgyzstan', phone: '+996', value: 'KG', currency: 'KGS' },
    { label: 'Laos', phone: '+856', value: 'LA', currency: 'LAK' },
    { label: 'Latvia', phone: '+371', value: 'LV', currency: 'EUR' },
    { label: 'Lebanon', phone: '+961', value: 'LB', currency: 'LBP' },
    { label: 'Lesotho', phone: '+266', value: 'LS', currency: 'LSL' },
    { label: 'Liberia', phone: '+231', value: 'LR', currency: 'LRD' },
    { label: 'Libya', phone: '+218', value: 'LY', currency: 'LYD' },
    { label: 'Liechtenstein', phone: '+423', value: 'LI', currency: 'CHF' },
    { label: 'Lithuania', phone: '+370', value: 'LT', currency: 'EUR' },
    { label: 'Luxembourg', phone: '+352', value: 'LU', currency: 'EUR' },
    { label: 'Macao', phone: '+853', value: 'MO', currency: 'MOP' },
    { label: 'Madagascar', phone: '+261', value: 'MG', currency: 'MGA' },
    { label: 'Malawi', phone: '+265', value: 'MW', currency: 'MWK' },
    { label: 'Malaysia', phone: '+60', value: 'MY', currency: 'MYR' },
    { label: 'Maldives', phone: '+960', value: 'MV', currency: 'MVR' },
    { label: 'Mali', phone: '+223', value: 'ML', currency: 'XOF' },
    { label: 'Malta', phone: '+356', value: 'MT', currency: 'EUR' },
    { label: 'Marshall Islands', phone: '+692', value: 'MH', currency: 'USD' },
    { label: 'Martinique', phone: '+596', value: 'MQ', currency: 'EUR' },
    { label: 'Mauritania', phone: '+222', value: 'MR', currency: 'MRU' },
    { label: 'Mauritius', phone: '+230', value: 'MU', currency: 'MUR' },
    { label: 'Mayotte', phone: '+262', value: 'YT', currency: 'EUR' },
    { label: 'Mexico', phone: '+52', value: 'MX', currency: 'MXN' },
    { label: 'Micronesia', phone: '+691', value: 'FM', currency: 'USD' },
    { label: 'Moldova', phone: '+373', value: 'MD', currency: 'MDL' },
    { label: 'Monaco', phone: '+377', value: 'MC', currency: 'EUR' },
    { label: 'Mongolia', phone: '+976', value: 'MN', currency: 'MNT' },
    { label: 'Montenegro', phone: '+382', value: 'ME', currency: 'EUR' },
    { label: 'Montserrat', phone: '+1664', value: 'MS', currency: 'XCD' },
    { label: 'Morocco', phone: '+212', value: 'MA', currency: 'MAD' },
    { label: 'Mozambique', phone: '+258', value: 'MZ', currency: 'MZN' },
    { label: 'Myanmar [Burma]', phone: '+95', value: 'MM', currency: 'MMK' },
    { label: 'Namibia', phone: '+264', value: 'NA', currency: 'NAD' },
    { label: 'Nauru', phone: '+674', value: 'NR', currency: 'AUD' },
    { label: 'Nepal', phone: '+977', value: 'NP', currency: 'NPR' },
    { label: 'Netherlands', phone: '+31', value: 'NL', currency: 'EUR' },
    { label: 'New Caledonia', phone: '+687', value: 'NC', currency: 'XPF' },
    { label: 'New Zealand', phone: '+64', value: 'NZ', currency: 'NZD' },
    { label: 'Nicaragua', phone: '+505', value: 'NI', currency: 'NIO' },
    { label: 'Niger', phone: '+227', value: 'NE', currency: 'XOF' },
    { label: 'Nigeria', phone: '+234', value: 'NG', currency: 'NGN' },
    { label: 'Niue', phone: '+683', value: 'NU', currency: 'NZD' },
    { label: 'Norfolk Island', phone: '+672', value: 'NF', currency: 'AUD' },
    { label: 'North Korea', phone: '+850', value: 'KP', currency: 'KPW' },
    { label: 'North Macedonia', phone: '+389', value: 'MK', currency: 'MKD' },
    { label: 'Northern Mariana Islands', phone: '+1670', value: 'MP', currency: 'USD' },
    { label: 'Norway', phone: '+47', value: 'NO', currency: 'NOK' },
    { label: 'Oman', phone: '+968', value: 'OM', currency: 'OMR' },
    { label: 'Pakistan', phone: '+92', value: 'PK', currency: 'PKR' },
    { label: 'Palau', phone: '+680', value: 'PW', currency: 'USD' },
    { label: 'Palestine', phone: '+970', value: 'PS', currency: 'ILS' },
    { label: 'Panama', phone: '+507', value: 'PA', currency: 'PAB' },
    { label: 'Papua New Guinea', phone: '+675', value: 'PG', currency: 'PGK' },
    { label: 'Paraguay', phone: '+595', value: 'PY', currency: 'PYG' },
    { label: 'Peru', phone: '+51', value: 'PE', currency: 'PEN' },
    { label: 'Philippines', phone: '+63', value: 'PH', currency: 'PHP' },
    { label: 'Pitcairn Islands', phone: '+64', value: 'PN', currency: 'NZD' },
    { label: 'Poland', phone: '+48', value: 'PL', currency: 'PLN' },
    { label: 'Portugal', phone: '+351', value: 'PT', currency: 'EUR' },
    { label: 'Puerto Rico', phone: '+1787,1939', value: 'PR', currency: 'USD' },
    { label: 'Qatar', phone: '+974', value: 'QA', currency: 'QAR' },
    { label: 'Republic of the Congo', phone: '+242', value: 'CG', currency: 'XAF' },
    { label: 'Romania', phone: '+40', value: 'RO', currency: 'RON' },
    { label: 'Russia', phone: '+7', value: 'RU', currency: 'RUB' },
    { label: 'Rwanda', phone: '+250', value: 'RW', currency: 'RWF' },
    { label: 'Réunion', phone: '+262', value: 'RE', currency: 'EUR' },
    { label: 'Saint Barthélemy', phone: '+590', value: 'BL', currency: 'EUR' },
    { label: 'Saint Helena', phone: '+290', value: 'SH', currency: 'SHP' },
    { label: 'Saint Kitts and Nevis', phone: '+1869', value: 'KN', currency: 'XCD' },
    { label: 'Saint Lucia', phone: '+1758', value: 'LC', currency: 'XCD' },
    { label: 'Saint Martin', phone: '+590', value: 'MF', currency: 'EUR' },
    { label: 'Saint Pierre and Miquelon', phone: '+508', value: 'PM', currency: 'EUR' },
    { label: 'Saint Vincent and the Grenadines', phone: '+1784', value: 'VC', currency: 'XCD' },
    { label: 'Samoa', phone: '+685', value: 'WS', currency: 'WST' },
    { label: 'San Marino', phone: '+378', value: 'SM', currency: 'EUR' },
    { label: 'Saudi Arabia', phone: '+966', value: 'SA', currency: 'SAR' },
    { label: 'Senegal', phone: '+221', value: 'SN', currency: 'XOF' },
    { label: 'Serbia', phone: '+381', value: 'RS', currency: 'RSD' },
    { label: 'Seychelles', phone: '+248', value: 'SC', currency: 'SCR' },
    { label: 'Sierra Leone', phone: '+232', value: 'SL', currency: 'SLL' },
    { label: 'Singapore', phone: '+65', value: 'SG', currency: 'SGD' },
    { label: 'Sint Maarten', phone: '+1721', value: 'SX', currency: 'ANG' },
    { label: 'Slovakia', phone: '+421', value: 'SK', currency: 'EUR' },
    { label: 'Slovenia', phone: '+386', value: 'SI', currency: 'EUR' },
    { label: 'Solomon Islands', phone: '+677', value: 'SB', currency: 'SBD' },
    { label: 'Somalia', phone: '+252', value: 'SO', currency: 'SOS' },
    { label: 'South Africa', phone: '+27', value: 'ZA', currency: 'ZAR' },
    { label: 'South Georgia and the South Sandwich Islands', phone: '+500', value: 'GS', currency: 'GBP' },
    { label: 'South Korea', phone: '+82', value: 'KR', currency: 'KRW' },
    { label: 'South Sudan', phone: '+211', value: 'SS', currency: 'SSP' },
    { label: 'Spain', phone: '+34', value: 'ES', currency: 'EUR' },
    { label: 'Sri Lanka', phone: '+94', value: 'LK', currency: 'LKR' },
    { label: 'Sudan', phone: '+249', value: 'SD', currency: 'SDG' },
    { label: 'Surilabel', phone: '+597', value: 'SR', currency: 'SRD' },
    { label: 'Svalbard and Jan Mayen', phone: '+4779', value: 'SJ', currency: 'NOK' },
    { label: 'Swaziland', phone: '+268', value: 'SZ', currency: 'SZL' },
    { label: 'Sweden', phone: '+46', value: 'SE', currency: 'SEK' },
    { label: 'Switzerland', phone: '+41', value: 'CH', currency: 'CHF' },
    { label: 'Syria', phone: '+963', value: 'SY', currency: 'SYP' },
    { label: 'São Tomé and Príncipe', phone: '+239', value: 'ST', currency: 'STN' },
    { label: 'Taiwan', phone: '+886', value: 'TW', currency: 'TWD' },
    { label: 'Tajikistan', phone: '+992', value: 'TJ', currency: 'TJS' },
    { label: 'Tanzania', phone: '+255', value: 'TZ', currency: 'TZS' },
    { label: 'Thailand', phone: '+66', value: 'TH', currency: 'THB' },
    { label: 'Togo', phone: '+228', value: 'TG', currency: 'XOF' },
    { label: 'Tokelau', phone: '+690', value: 'TK', currency: 'NZD' },
    { label: 'Tonga', phone: '+676', value: 'TO', currency: 'TOP' },
    { label: 'Trinidad and Tobago', phone: '+1868', value: 'TT', currency: 'TTD' },
    { label: 'Tunisia', phone: '+216', value: 'TN', currency: 'TND' },
    { label: 'Turkey', phone: '+90', value: 'TR', currency: 'TRY' },
    { label: 'Turkmenistan', phone: '+993', value: 'TM', currency: 'TMT' },
    { label: 'Turks and Caicos Islands', phone: '+1649', value: 'TC', currency: 'USD' },
    { label: 'Tuvalu', phone: '+688', value: 'TV', currency: 'AUD' },
    { label: 'U.S. Minor Outlying Islands', phone: '+1', value: 'UM', currency: 'USD' },
    { label: 'U.S. Virgin Islands', phone: '+1340', value: 'VI', currency: 'USD' },
    { label: 'Uganda', phone: '+256', value: 'UG', currency: 'UGX' },
    { label: 'Ukraine', phone: '+380', value: 'UA', currency: 'UAH' },
    { label: 'United Arab Emirates', phone: '+971', value: 'AE', currency: 'AED' },
    { label: 'United Kingdom', phone: '+44', value: 'GB', currency: 'GBP' },
    { label: 'United States', phone: '+1', value: 'US', currency: 'USD' },
    { label: 'Uruguay', phone: '+598', value: 'UY', currency: 'UYU' },
    { label: 'Uzbekistan', phone: '+998', value: 'UZ', currency: 'UZS' },
    { label: 'Vanuatu', phone: '+678', value: 'VU', currency: 'VUV' },
    { label: 'Vatican City', phone: '+379', value: 'VA', currency: 'EUR' },
    { label: 'Venezuela', phone: '+58', value: 'VE', currency: 'VES' },
    { label: 'Vietnam', phone: '+84', value: 'VN', currency: 'VND' },
    { label: 'Wallis and Futuna', phone: '+681', value: 'WF', currency: 'XPF' },
    { label: 'Western Sahara', phone: '+212', value: 'EH', currency: 'MAD' },
    { label: 'Yemen', phone: '+967', value: 'YE', currency: 'YER' },
    { label: 'Zambia', phone: '+260', value: 'ZM', currency: 'ZMW' },
    { label: 'Zimbabwe', phone: '+263', value: 'ZW', currency: 'ZWL' },
    { label: 'Åland', phone: '+358', value: 'AX', currency: 'EUR' },
  ],
  SOCIALS_BACKGROUND: {
    discord_link: "#6f85dc",
    instagram_link: "#C13584",
    twitter_link: "#1DA1F2",
    youtube_link: "#FF0000",
    facebook_link: "#4267B2",
    reddit_link: "#FF4500",
    telegram_link: "#0088cc",
    tiktok_link: "#EE1D52",
    crisp_website_id: "purple",
    helpspace: "white",
    google_analytics_tracking_id: "transparent",
  },

  SOCIALS_ICONS: {
    discord_link: <i style={{ fontSize: 22, color: "white" }} className="fa-brands fa-discord" />,
    instagram_link: <i style={{ fontSize: 22, color: "white" }} className="fa-brands fa-instagram" />,
    twitter_link: <i style={{ fontSize: 22, color: "white" }} className="fa-brands fa-twitter" />,
    youtube_link: <i style={{ fontSize: 22, color: "white" }} className="fa-brands fa-youtube" />,
    facebook_link: <i style={{ fontSize: 22, color: "white" }} className="fa-brands fa-facebook" />,
    reddit_link: <i style={{ fontSize: 22, color: "white" }} className="fa-brands fa-reddit-alien" />,
    telegram_link: <i style={{ fontSize: 22, color: "white" }} className="fa-brands fa-telegram" />,
    tiktok_link: <i style={{ fontSize: 22, color: "white" }} className="fa-brands fa-tiktok" />,
    crisp_website_id: <img src={`https://cdn.paylix.gg/static/socials/crisp.svg`} alt="Crisp" />,
    helpspace: <img src={`https://cdn-1.webcatalog.io/catalog/helpspace/helpspace-icon-filled.png?v=1651639952897`} alt="HelpSpace" />,
    google_analytics_tracking_id: <img src={`https://cdn.paylix.gg/cdn-cgi/image/w=30,h=30,quality=75,fit=cover/static/socials/google-analytics-l.png`} alt="Google Analytics" />,
  },

  STRIPE_PUBLIC_KEY: "pk_live_51RC35TLK39jtsWD52Htyx1uA0qcb9AmlUTBpWHZbjSnVcOUhKg4aGv6dwj6eF1lhNpYo5RpEZyVJcfYKRZCoYUpy00bCP260s7",
  // STRIPE_PUBLIC_KEY: "pk_test_51JpGudGGvSAAHahBtsjlSuJtXjc4mC2hWU0302laSQBqh1iZsfKDH4pWkSj7lc6GyGTQd8AJiGh0pd9RVU4SmMzQ00bOMDGqed",

  API_ROOT_LOCAL: 'https://api.paylixecommerce.aws:23596/v1',
  API_ROOT_SERVER_REQUESTS: 'https://api-internal.paylix.gg/v1',
  API_ROOT: 'https://api-internal.paylix.gg/v1',
  API_THEME_BUILDER_ROOT: 'https://api-internal.paylix.gg/v1',

  API_ROOT_DOWNLOAD_FILE: 'https://api-dl.paylix.gg/v1',
  API_ROOT_DOWNLOAD: 'https://api-dlv.paylix.gg/v1',
  API_ROOT_DEVELOPER: 'https://dev.paylix.gg/api/v1',

  CAPTCHA_SITE_KEY: '6LfO0QwrAAAAAMc2H6SCObbH_yruosPSkcjk-ZYM',
  CAPTCHA_SITE_KEY_V3: '6LdSRgkrAAAAAJQsgstDpo76FHDYV9y2kdSj7mV7',
  // GOOGLE_CLIENT_ID: '1057841909044-lc89cgsardjnae7dqm855ergsd9l55dt.apps.googleusercontent.com',
  GOOGLE_CLIENT_ID: '700688050359-ek2ljbdutjgdcgtc8mghlcomipvirk4s.apps.googleusercontent.com',
  CDN_FLAGS_URL: 'https://cdn.paylix.gg/static/flags/',
  CDN_LANDING_URL: 'https://cdn.paylix.gg/static/landing',
  CDN_LOGO_URL: 'https://cdn.paylix.gg/static/logo',
  CDN_CRYPTO_URL: 'https://cdn.paylix.gg/static/crypto',
  CDN_PREVIEWS_URL: 'https://cdn.paylix.gg/static/previews',
  CDN_PREVIEWS_LANDING_URL: 'https://cdn.paylix.gg/static/previews/landing',
  INTERCOM_ID: 'j3kaf0pd',
  GOOGLE_AUTH_ID: '700688050359-ek2ljbdutjgdcgtc8mghlcomipvirk4s.apps.googleusercontent.com',
  STATUS_ICON: {
    'PENDING': pendingIcon,
    'COMPLETED': completedIcon,
    'VOIDED': cancelledIcon,
    'PARTIAL': paritalIcon,
    'REVERSED': cancelledIcon,
    'REFUNDED': cancelledIcon
  },

  DISPUTES_OPTIONS: [
    {value: 'all', label: 'All'},
    {value: 'OPEN', label: 'Open'},
    {value: 'WAITING_FOR_BUYER_RESPONSE', label: 'Waiting For Buyer Response'},
    {value: 'WAITING_FOR_SELLER_RESPONSE', label: 'Waiting For Seller Response'},
    {value: 'UNDER_REVIEW', label: 'Under Review'},
    {value: 'RESOLVED', label: 'Resolved'},
    {value: 'OTHER', label: 'Other'}
  ],

  CURRENCY_OPTIONS: {
    USD: { key: 'USD', name: 'USD', title: 'US Dollar', symbol: '$', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/us.svg`, priority: 1000 },
    EUR: { key: 'EUR', name: 'EUR', title: 'Euro', symbol: '€', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/eu.svg`, priority: 950 },
    GBP: { key: 'GBP', name: 'GBP', title: 'British Pound Sterling', symbol: '£', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/gb.svg`, priority: 900 },
    CHF: { key: 'CHF', name: 'CHF', title: 'Swiss Franc', symbol: '₣', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/ch.svg`, priority: 850 },
    CNY: { key: 'CNY', name: 'CNY', title: 'Chinese Yuan', symbol: '¥', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/cn.svg`, priority: 800 },
    AUD: { key: 'AUD', name: 'AUD', title: 'Australian Dollar', symbol: 'A$', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/au.svg`, priority: 750 },
    CAD: { key: 'CAD', name: 'CAD', title: 'Canadian Dollar', symbol: 'C$', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/ca.svg`, priority: 700 },
    JPY: { key: 'JPY', name: 'JPY', title: 'Japanese Yen', symbol: '¥', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/jp.svg`, priority: 100 },
    SEK: { key: 'SEK', name: 'SEK', title: 'Swedish Krona', symbol: 'kr', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/se.svg`, priority: 100 },
    NZD: { key: 'NZD', name: 'NZD', title: 'New Zealand Dollar', symbol: 'ZN$', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/nz.svg`, priority: 100 },
    PLN: { key: 'PLN', name: 'PLN', title: 'Polish Złoty', symbol: 'zł', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/pl.svg`, priority: 100 },
    ILS: { key: 'ILS', name: 'ILS', title: 'Israeli New Shekel', symbol: '₪', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/il.svg`, priority: 100 },

    HKD: { key: 'HKD', name: 'HKD', title: 'Hong Kong Dollar', symbol: 'HK$', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/hk.svg`, priority: 100 },
    ISK: { key: 'ISK', name: 'ISK', title: 'Icelandic Króna', symbol: 'Íkr', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/is.svg`, priority: 100 },
    PHP: { key: 'PHP', name: 'PHP', title: 'Philippine Peso', symbol: '₱', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/ph.svg`, priority: 100 },
    DKK: { key: 'DKK', name: 'DKK', title: 'Danish Krone', symbol: 'Kr.', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/dk.svg`, priority: 100 },
    HUF: { key: 'HUF', name: 'HUF', title: 'Hungarian Forint', symbol: 'Ft', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/hu.svg`, priority: 100 },
    CZK: { key: 'CZK', name: 'CZK', title: 'Czech Koruna', symbol: 'Kč', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/cz.svg`, priority: 100 },
    RON: { key: 'RON', name: 'RON', title: 'Romanian Leu', symbol: 'L', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/ro.svg`, priority: 100 },

    IDR: { key: 'IDR', name: 'IDR', title: 'Indonesian Rupiah', symbol: 'Rp', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/id.svg`, priority: 100 },
    INR: { key: 'INR', name: 'INR', title: 'Indian Rupee', symbol: '₹', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/in.svg`, priority: 100 },
    BRL: { key: 'BRL', name: 'BRL', title: 'Brazilian Real', symbol: 'R$', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/br.svg`, priority: 100 },
    RUB: { key: 'RUB', name: 'RUB', title: 'Russian Ruble', symbol: '₽', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/ru.svg`, priority: 100 },
    HRK: { key: 'HRK', name: 'HRK', title: 'Croatian Kuna', symbol: 'Kn', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/hr.svg`, priority: 100 },
    THB: { key: 'THB', name: 'THB', title: 'Thai Baht', symbol: '฿', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/th.svg`, priority: 100 },
    MYR: { key: 'MYR', name: 'MYR', title: 'Malaysian Ringgit', symbol: 'RM', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/my.svg`, priority: 100 },

    BGN: { key: 'BGN', name: 'BGN', title: 'Bulgarian Lev', symbol: 'лв.', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/bg.svg`, priority: 100 },
    TRY: { key: 'TRY', name: 'TRY', title: 'Turkish Lira', symbol: '₺', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/tr.svg`, priority: 100 },
    NOK: { key: 'NOK', name: 'NOK', title: 'Norwegian Krone', symbol: 'kr', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/no.svg`, priority: 100 },
    ZAR: { key: 'ZAR', name: 'ZAR', title: 'South African Rand', symbol: 'R', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/za.svg`, priority: 100 },
    MXN: { key: 'MXN', name: 'MXN', title: 'Mexican Peso', symbol: 'Mex$', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/mx.svg`, priority: 100 },
    SGD: { key: 'SGD', name: 'SGD', title: 'Singapore Dollar', symbol: 'S$', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/sg.svg`, priority: 100 },
    KRW: { key: 'KRW', name: 'KRW', title: 'South Korean Won', symbol: '₩', type: 'fiat', imgUrl: `${CDN_FLAGS_URL}/kr.svg`, priority: 100 },

  },
  CURRENCY_LIST : {
    'USD': '$',
    'EUR': '€',
    'AUD': 'A$',
    'GBP': '£',
    'JPY': '¥',
    'CAD': 'C$',
    'CHF': 'CHF',
    'CNY': '¥',
    'SEK': 'kr',
    'NZD': 'NZD',
    'PLN': 'zł',
    'ILS': '₪',

    'HKD': 'HK$',
    'ISK': 'Íkr',
    'PHP': '₱',
    'DKK': 'Kr.',
    'HUF': 'Ft',
    'CZK': 'Kč',
    'RON': 'L',

    'IDR': 'Rp',
    'INR': '₹',
    'BRL': 'R$',
    'RUB': '₽',
    'HRK': 'Kn',
    'THB': '฿',
    'MYR': 'RM',

    'BGN': 'лв.',
    'TRY': '₺',
    'NOK': 'kr ',
    'ZAR': 'R',
    'MXN': 'Mex$',
    'SGD': 'S$',
    'KRW': '₩'
  },

  WARRANTY_OPTIONS: [
    { value: '0', label: 'No Warranty'},
    { value: '-1', label: 'Life Time'},
    { value: '900', label: '15 minutes'},
    { value: '3600', label: '1 hour'},
    { value: '7200', label: '2 hours'},
    { value: '43200', label: '12 hours'},
    { value: '86400', label: '24 hours'},
    { value: '604800', label: '7 days'},
    { value: '1209600', label: '14 days'},
    { value: '2592000', label: '30 days'},
    { value: '31536000', label: '365 days'},
    { value: '1', label: 'Input manually'}
  ],
  APPEAL_REASON_OPTIONS: [
    { value: 'FALSE_OR_MISLEADING', label: 'False or Misleading'},
    { value: 'REFERRING_ANOTHER_SHOP', label: 'Referring Another Shop'},
    { value: 'INVOICE_REPLACED', label: 'Invoice Replaced'},
    { value: 'WRONG_VALUATION', label: 'Wrong Valuation'},
    { value: 'OTHER', label: 'Other'},
  ],

  SUB_TYPE_OPTIONS: [
    { value: 'SERIALS', label: 'Serials'},
    { value: 'FILE', label: 'File'},
    { value: 'SERVICE', label: 'Service'},
    { value: 'DYNAMIC', label: 'Dynamic'},
  ],

  STATUS_OPTIONS: [
     {value: 'all', label: 'Statuses'},
     {value: 'PENDING', label: 'Pending'},
     {value: 'PARTIAL', label: 'Partial'},
     {value: 'COMPLETED', label: 'Completed'},
     {value: 'VOIDED', label: 'Cancelled'},
     {value: 'WAITING_FOR_CONFIRMATIONS', label: 'Confirmation'},
     {value: 'WAITING_SHOP_ACTION', label: 'Shop Action'},
     {value: 'REVERSED', label: 'Reversed'},
     {value: 'REFUNDED', label: 'Refunded'},
     {value: 'CUSTOMER_DISPUTE_ONGOING', label: 'Ongoing Dispute'}
  ],



  DISPUTES_STATUSES: {
    OPEN: "Open",
    UNDER_REVIEW: "Under Review",
    WAITING_FOR_BUYER_RESPONSE: "Waiting for Buyer Response",
    RESOLVED: "Resolved",
    WAITING_FOR_SELLER_RESPONSE: "Waiting for Seller Response",
    OTHER: "Other",
    'warning_needs_response': 'Warning Needs Response',
    'warning_under_review': 'Warning Under Review',
    'warning_closed': 'Warning Closed',
    'needs_response': 'Needs Response',
    'under_review': 'Under Review',
    'charge_refunded': 'Charge Refunded',
    'won': 'Won',
    'lost': 'Lost'
  },

  DISPUTES_REASONS: {
    MERCHANDISE_OR_SERVICE_NOT_RECEIVED: "Merchandise or Service Not Received",
    INCORRECT_AMOUNT: "Incorrect Amount",
    MERCHANDISE_OR_SERVICE_NOT_AS_DESCRIBED: "Merchandise or Service not as Described",
    PAYMENT_BY_OTHER_MEANS: "Payment by Other Means",
    UNAUTHORISED: "Unauthorised",
    CANCELED_RECURRING_BILLING: "Canceled Recurring Billing",
    CREDIT_NOT_PROCESSED: "Credit not Processed",
    PROBLEM_WITH_REMITTANCE: "Problem with Remittance",
    DUPLICATE_TRANSACTION: "Duplicate Transaction",
    OTHER: "Other",
    'bank_cannot_process': 'Bank Cannot Process',
    'check_returned': 'Check Returned',
    'credit_not_processed': 'Credit not Processed',
    'customer_initiated': 'Customer Initiated',
    'debit_not_authorized': 'Debit not Authorized',
    'duplicate': 'Duplicate',
    'fraudulent': 'Fraudulent',
    'general': 'General',
    'incorrect_account_details': 'Incorrect Account Details',
    'insufficient_funds': 'Insufficient Funds',
    'product_not_received': 'Product not Received',
    'product_unacceptable': 'Product Unacceptable',
    'subscription_canceled': 'Subscription Canceled',
    'unrecognized': 'Unrecognized'
  },

  CARDS: {
    VISA: "https://cdn.paylix.gg/static/gateways/visa.svg",
    MASTERCARD: "https://cdn.paylix.gg/static/gateways/mastercard.png",
    AMERICANEXPRESS: "https://cdn.paylix.gg/static/gateways/american-express.png",
    APPLEPAY: "https://cdn.paylix.gg/static/gateways/apple-pay-logo-icon.png",
    GOOGLEPAY: "https://cdn.paylix.gg/static/gateways/google-pay.svg",
  },

  PAYMENT_ICONS: {

    ATOM: "https://cdn.paylix.gg/static/gateways/new/atom.svg",
    DOGE: "https://cdn.paylix.gg/static/gateways/new/doge.svg",
    FLOW: "https://cdn.paylix.gg/static/gateways/new/flow.svg",

    PAYPAL: "https://cdn.paylix.gg/static/gateways/new/paypal.svg",
    NANO: "https://cdn.paylix.gg/static/gateways/new/nano.svg",
    BITCOIN: "https://cdn.paylix.gg/static/gateways/new/bitcoin.svg",
    LITECOIN: "https://cdn.paylix.gg/static/gateways/new/litecoin.svg",
    TRON: "https://cdn.paylix.gg/static/gateways/new/tron.svg",
    ETHEREUM: "https://cdn.paylix.gg/static/gateways/new/ethereum.svg",
    CONCORDIUM: "https://cdn.paylix.gg/static/gateways/new/concordium.svg",
    BINANCE_COIN: "https://cdn.paylix.gg/static/gateways/new/binance-coin.svg",
    CRONOS: "https://cdn.paylix.gg/static/gateways/new/cronos.svg",
    USDC: "https://cdn.paylix.gg/static/gateways/new/usdc.svg",
    "USDC:BEP20": "https://cdn.paylix.gg/static/gateways/new/usdc.svg",
    "USDC:ERC20": "https://cdn.paylix.gg/static/gateways/new/usdc.svg",
    "USDC:MATIC": "https://cdn.paylix.gg/static/gateways/new/usdc.svg",
    "USDC_NATIVE": "https://cdn.paylix.gg/static/gateways/new/usdc.svg",
    "USDC_NATIVE:MATIC": "https://cdn.paylix.gg/static/gateways/new/usdc.svg",
    USDT: "https://cdn.paylix.gg/static/gateways/new/usdt.svg",
    "USDT:BEP20": "https://cdn.paylix.gg/static/gateways/new/usdt.svg",
    "USDT:ERC20": "https://cdn.paylix.gg/static/gateways/new/usdt.svg",
    "USDT:TRC20": "https://cdn.paylix.gg/static/gateways/new/usdt.svg",
    "USDT:MATIC": "https://cdn.paylix.gg/static/gateways/new/usdt.svg",


    DAI: "https://cdn.paylix.gg/static/gateways/new/dai.svg",
    "DAI:BEP20": "https://cdn.paylix.gg/static/gateways/new/dai.svg",
    "DAI:ERC20": "https://cdn.paylix.gg/static/gateways/new/dai.svg",
    "DAI:MATIC": "https://cdn.paylix.gg/static/gateways/new/dai.svg",

    SHIB: "https://cdn.paylix.gg/static/gateways/new/shib.svg",
    "SHIB:BEP20": "https://cdn.paylix.gg/static/gateways/new/shib.svg",
    "SHIB:ERC20": "https://cdn.paylix.gg/static/gateways/new/shib.svg",
    "SHIB:MATIC": "https://cdn.paylix.gg/static/gateways/new/shib.svg",

    APE: "https://cdn.paylix.gg/static/gateways/new/ape.svg",
    "APE:ERC20": "https://cdn.paylix.gg/static/gateways/new/ape.svg",

    PEPE: "https://cdn.paylix.gg/static/gateways/new/pepe.svg",
    "PEPE:ERC20": "https://cdn.paylix.gg/static/gateways/new/pepe.svg",


    WETH: "https://cdn.paylix.gg/static/gateways/new/weth.svg",
    "WETH:ERC20": "https://cdn.paylix.gg/static/gateways/new/weth.svg",
    "WETH:MATIC": "https://cdn.paylix.gg/static/gateways/new/weth.svg",


    PLZ: "https://cdn.paylix.gg/static/gateways/new/plz.svg",
    "PLZ:TRC20": "https://cdn.paylix.gg/static/gateways/new/plz.svg",
    "PLZ:BEP20": "https://cdn.paylix.gg/static/gateways/new/plz.svg",

    POLYGON: "https://cdn.paylix.gg/static/gateways/new/polygon.svg",

    BITCOIN_CASH: "https://cdn.paylix.gg/static/gateways/new/bitcoin-cash.svg",
    MONERO: "https://cdn.paylix.gg/static/gateways/new/monero.svg",
    BITCOIN_LN: "https://cdn.paylix.gg/static/gateways/new/bitcoin-ln.svg",
    BINANCE: "https://cdn.paylix.gg/static/gateways/new/binance.svg",
    SKRILL: "https://cdn.paylix.gg/static/gateways/new/skrill.svg",
    PERFECT_MONEY: "https://cdn.paylix.gg/static/gateways/new/perfect-money.svg",
    CASH_APP: "https://cdn.paylix.gg/static/gateways/new/cashapp.svg",
    STRIPE: "https://cdn.paylix.gg/static/gateways/new/stripe.svg",
    SOLANA: "https://cdn.paylix.gg/static/gateways/new/solana.svg",
    RIPPLE: "https://cdn.paylix.gg/static/gateways/new/ripple.svg",

    CARD: "https://cdn.paylix.gg/static/gateways/credit-card.png",

    PAYPAL_EXTRA: {
      BLIK: "https://cdn.paylix.gg/static/gateways/blik.svg",
      EPS: "https://cdn.paylix.gg/static/gateways/eps.png",
      GIROPAY: "https://cdn.paylix.gg/static/gateways/giropay.svg",
      IDEAL: "https://cdn.paylix.gg/static/gateways/ideal.png",
      MERCADOPAGO: "https://cdn.paylix.gg/static/gateways/mercado-pago.png",
      MYBANK: "https://cdn.paylix.gg/static/gateways/mybank.png",
      PAYLATER: "https://cdn.paylix.gg/static/gateways/paylater.jpg",
      PRZELEWY24: "https://cdn.paylix.gg/static/gateways/przelewy24.png",
      SEPA: "https://cdn.paylix.gg/static/gateways/sepa.png",
      SOFORT: "https://cdn.paylix.gg/static/gateways/sofort.png",
      VENMO: "https://cdn.paylix.gg/static/gateways/venmo.png",
      BANCONTACT: "https://cdn.paylix.gg/static/gateways/bancontact.png",
      TRUSTLY: "https://cdn.paylix.gg/static/gateways/trustly.png",
    },

    STRIPE_EXTRA: {
      AFTERPAY_CLEARPAY: "https://cdn.paylix.gg/static/gateways/afterpay.png",
      ALIPAY: "https://cdn.paylix.gg/static/gateways/alipay.png",
      BANCONTACT: "https://cdn.paylix.gg/static/gateways/bancontact.png",
      AU_BECS_DEBIT: "https://cdn.paylix.gg/static/gateways/becs.png",
      BOLETO: "https://cdn.paylix.gg/static/gateways/boleto.png",
      EPS: "https://cdn.paylix.gg/static/gateways/eps.png",
      FPX: "https://cdn.paylix.gg/static/gateways/fpx.jpeg",
      GIROPAY: "https://cdn.paylix.gg/static/gateways/giropay.svg",
      GRABPAY: "https://cdn.paylix.gg/static/gateways/grabpay.jpeg",
      IDEAL: "https://cdn.paylix.gg/static/gateways/ideal.png",
      KLARNA: "https://cdn.paylix.gg/static/gateways/klarna.jpeg",
      OXXO: "https://cdn.paylix.gg/static/gateways/oxxo.png",
      PRZELEWY24: "https://cdn.paylix.gg/static/gateways/przelewy24.png",
      SEPA: "https://cdn.paylix.gg/static/gateways/sepa.png",
      SOFORT: "https://cdn.paylix.gg/static/gateways/sofort.png",
      WECHAT_PAY: "https://cdn.paylix.gg/static/gateways/wechat.png",
      PROMPTPAY: "https://cdn.paylix.gg/static/gateways/wechat.png",
      CASH_APP: "https://cdn.paylix.gg/static/gateways/new/cashapp.svg",
    },
  },

  BLOCKCHAIN_OPTIONS: [
     {value: 'all', label: 'Blockchains'},
     {value: 'TRC20', label: 'Tron'},
     {value: 'ERC20', label: 'Ethereum'},
     {value: 'BEP20', label: 'Binance Smart Chain'},
     {value: 'MATIC', label: 'Polygon'},
  ],

  GATEWAY_OPTIONS: [
     {value: 'all', label: 'Gateways'},
     {value: 'PAYPAL', label: 'PayPal'},
     {value: 'BITCOIN', label: 'Bitcoin'},
     {value: 'LITECOIN', label: 'Litecoin'},
     {value: 'TRON', label: 'Tron'},
     {value: 'ETHEREUM', label: 'Ethereum'},
     {value: 'BINANCE_COIN', label: 'Binance Coin'},
     {value: 'CRONOS', label: 'Cronos'},
     {value: 'USDC', label: 'USDC'},
     {value: 'USDC_NATIVE', label: 'USDC Native'},
     {value: 'USDT', label: 'USDT'},

     {value: 'DAI', label: 'DAI'},
     {value: 'SHIB', label: 'Shiba Inu'},
     {value: 'APE', label: 'ApeCoin'},
     {value: 'PEPE', label: 'Pepe'},
     {value: 'WETH', label: 'WETH'},

     {value: 'PLZ', label: 'Plaentz Token'},
     {value: 'POLYGON', label: 'Polygon'},
     {value: 'BITCOIN_CASH', label: 'Bitcoin Cash'},
     {value: 'NANO', label: 'Nano'},
     {value: 'MONERO', label: 'Monero'},
     {value: 'BITCOIN_LN', label: 'Bitcoin Lightning Network'},
     {value: 'CONCORDIUM', label: 'Concordium'},
     {value: 'BINANCE', label: 'Binance'},

     {value: 'RIPPLE', label: 'Ripple'},
     {value: 'SOLANA', label: 'Solana'},

     {value: 'SKRILL', label: 'Skrill'},
     {value: 'PERFECT_MONEY', label: 'Perfect Money'},
     {value: 'CASH_APP', label: 'Cash App'},
     {value: 'STRIPE', label: 'Stripe'}
  ],

  PAYPAL_APM: {
    BLIK: "blik",
    EPS: "eps",
    GIROPAY: "giropay",
    IDEAL: "ideal",
    MERCADOPAGO: "mercadopago",
    MYBANK: "mybank",
    PAYLATER: "paylater",
    PRZELEWY24: "p24",
    SEPA: "sepa",
    SOFORT: "sofort",
    VENMO: "venmo",
    BANCONTACT: "bancontact",
    TRUSTLY: "trustly",
    CREDIT: "credit",
  },

  STRIPE_APM: {
    PROMPTPAY: "promptpay",
    AFTERPAY_CLEARPAY: "afterpay_clearpay",
    ALIPAY: "alipay",
    BANCONTACT: "bancontact",
    AU_BECS_DEBIT: "au_becs_debit",
    BOLETO: "boleto",
    EPS: "eps",
    FPX: "fpx",
    GIROPAY: "giropay",
    GRABPAY: "grabpay",
    IDEAL: "ideal",
    KLARNA: "klarna",
    OXXO: "oxxo",
    PRZELEWY24: "p24",
    SEPA: "sepa_debit",
    SOFORT: "sofort",
    WECHAT_PAY: "wechat_pay",
    CASH_APP: "cashapp",
  },

  PAYMENT_OPTS : {
    PAYPAL: 'PayPal',

    BITCOIN: 'BTC',
    LITECOIN: 'LTC',
    TRON: 'TRX',
    ETHEREUM: 'ETH',
    BINANCE_COIN: 'BNB',
    CRONOS: 'CRO',
    USDC: 'USDC',
    USDC_NATIVE: 'USDC Native',
    USDT: 'USDT',

    DAI: "DAI",
    SHIB: "SHIB",
    APE: "APE",
    PEPE: "PEPE",
    WETH: "WETH",

    BITCOIN_CASH: 'BCH',
    NANO: 'NANO',
    MONERO: 'XMR',
    BITCOIN_LN: 'BTC LN',
    CONCORDIUM: 'CCD',
    BINANCE: 'USDT',
    RIPPLE: 'XRP',
    SOLANA: 'SOL',
    POLYGON: 'POLYGON',
    PLZ: 'PLZ',

    SKRILL: 'Skrill',
    PERFECT_MONEY: 'Perfect Money',
    CASH_APP: 'Cash App',
    STRIPE: 'Stripe',

    CARD: 'Credit Card',

    PAYPAL_EXTRA: {
      BLIK: "BLIK",
      EPS: "eps",
      GIROPAY: "giropay",
      IDEAL: "iDEAL",
      MERCADOPAGO: "Mercado Pago",
      MYBANK: "MyBank",
      PAYLATER: "Pay Later",
      PRZELEWY24: "Przelewy24",
      SEPA: "SEPA-Lastschrift",
      SOFORT: "Sofort",
      VENMO: "Venmo",
      BANCONTACT: "Bancontact",
      TRUSTLY: "Trustly",
    },

    STRIPE_EXTRA: {
      PROMPTPAY: "PromptPay",
      AFTERPAY_CLEARPAY: "Afterpay and Clearpay",
      ALIPAY: "Alipay",
      BANCONTACT: "Bancontact",
      AU_BECS_DEBIT: "BECS",
      BOLETO: "Boleto",
      EPS: "EPS",
      FPX: "FPX",
      GIROPAY: "Giropay",
      GRABPAY: "GrabPay",
      IDEAL: "iDEAL",
      KLARNA: "Klarna",
      OXXO: "OXXO",
      PRZELEWY24: "P24",
      SEPA: "SEPA",
      SOFORT: "Sofort",
      WECHAT_PAY: "WeChat Pay",
      CASH_APP: "Cashapp",
    }
  },

  PAYMENT_FULL_NAME : {
    PAYPAL: 'PayPal',

    BITCOIN: 'Bitcoin',
    LITECOIN: 'Litecoin',
    TRON: 'Tron',
    ETHEREUM: 'Ethereum',
    BINANCE_COIN: 'Binance Coin',
    CRONOS: 'Cronos',
    USDC: 'USDC',
    "USDC:BEP20": 'USDC (BEP20)',
    "USDC:ERC20": 'USDC (ERC20)',
    "USDC:MATIC": 'USDC.e Bridged (MATIC)',
    "USDC_NATIVE": 'USDC Native',
    "USDC_NATIVE:MATIC": 'USDC Native (MATIC)',
    USDT: 'USDT',
    "USDT:BEP20": 'USDT (BEP20)',
    "USDT:ERC20": 'USDT (ERC20)',
    "USDT:TRC20": 'USDT (TRC20)',
    "USDT:MATIC": 'USDT (MATIC)',

    SHIB: "Shiba Inu",
    "SHIB:BEP20": "Shiba Inu (BEP20)",
    "SHIB:ERC20": "Shiba Inu (ERC20)",
    "SHIB:MATIC": "Shiba Inu (MATIC)",

    DAI: "DAI",
    "DAI:BEP20": "DAI (BEP20)",
    "DAI:ERC20": "DAI (ERC20)",
    "DAI:MATIC": "DAI (MATIC)",

    WETH: "WETH",
    "WETH:ERC20": "WETH (ERC20)",
    "WETH:MATIC": "WETH (MATIC)",

    PEPE: "PEPE",
    "PEPE:ERC20": "Pepe (ERC20)",

    APE: "ApeCoin",
    "APE:ERC20": "ApeCoin (ERC20)",

    BITCOIN_CASH: 'Bitcoin Cash',
    NANO: 'Nano',
    MONERO: 'Monero',
    BITCOIN_LN: 'Bitcoin Lightning Network',
    CONCORDIUM: 'Concordium',
    BINANCE: 'Binance',

    POLYGON: 'Polygon',
    PLZ: 'Plaentz Token',
    "PLZ:TRC20": "Plaentz Token (TRC20)",
    "PLZ:BEP20": "Plaentz Token (BEP20)",

    SOLANA: 'Solana',
    RIPPLE: 'Ripple',

    SKRILL: 'Skrill',
    PERFECT_MONEY: 'Perfect Money',
    CASH_APP: 'Cash App',
    STRIPE: 'Stripe',

    CARD: 'Credit Card',
    PAYPAL_CREDIT_CARD: 'Credit Card',

    PAYPAL_EXTRA: {
      BLIK: "BLIK",
      EPS: "eps",
      GIROPAY: "giropay",
      IDEAL: "iDEAL",
      MERCADOPAGO: "Mercado Pago",
      MYBANK: "MyBank",
      PAYLATER: "Pay Later",
      PRZELEWY24: "Przelewy24",
      SEPA: "SEPA-Lastschrift",
      SOFORT: "Sofort",
      VENMO: "Venmo",
      BANCONTACT: "Bancontact",
      TRUSTLY: "Trustly",
    },

    STRIPE_EXTRA: {
      PROMPTPAY: "PromptPay",
      AFTERPAY_CLEARPAY: "Afterpay and Clearpay",
      ALIPAY: "Alipay",
      BANCONTACT: "Bancontact",
      AU_BECS_DEBIT: "BECS",
      BOLETO: "Boleto",
      EPS: "EPS",
      FPX: "FPX",
      GIROPAY: "Giropay",
      GRABPAY: "GrabPay",
      IDEAL: "iDEAL",
      KLARNA: "Klarna",
      OXXO: "OXXO",
      PRZELEWY24: "P24",
      SEPA: "SEPA",
      SOFORT: "Sofort",
      WECHAT_PAY: "WeChat Pay",
      CASH_APP: "Cashapp",
    }
  },

  PAYMENT_TYPE_OPTIONS: [
    { value: '0', label: 'Single Payment' },
    { value: '1', label: 'Pay what you want' },
  ],

  AFFILIATE_TYPE_OPTIONS: [
    { value: -1, label: 'Disabled' },
    { value: 0, label: 'Default' },
    { value: 'CUSTOM', label: 'Custom' },
  ],

  GATEWAY_FEES_TYPE: {
    PERCENT: 'PERCENT',
    FIXED: 'FIXED'
  },

  ORDER_STATUS: {
    PENDING: 'Pending',
    COMPLETED: 'Completed',
    VOIDED: 'Cancelled',
    WAITING_FOR_CONFIRMATIONS: 'Confirmation',
    WAITING_SHOP_ACTION: 'Waiting for shop action',
    PARTIAL: 'Partial',
    REVERSED: 'Reversed',
    REFUNDED: 'Refunded',
    CUSTOMER_DISPUTE_ONGOING: 'Ongoing Dispute',
    PROCESSING: "Processing",
  },

  TYPE_OPTIONS: [
    { value: 'FILE', label: 'File' },
    { value: 'SERIALS', label: 'Serials' },
    { value: 'SERVICE', label: 'Service' },
    { value: 'DYNAMIC', label: 'Dynamic' },
    { value: 'SUBSCRIPTION', label: 'Subscription' },
  ],

  TYPE_OPTIONS_VARIANT: [
    { value: 'FILE', label: 'File' },
    { value: 'SERIALS', label: 'Serials' },
    { value: 'SERVICE', label: 'Service' },
    { value: 'DYNAMIC', label: 'Dynamic' }
  ],

  SUBTYPE_OPTIONS: [
    { value: '', label: 'Classic' },
    { value: 'FILE', label: 'File' },
    { value: 'SERIALS', label: 'Serials' },
    { value: 'SERVICE', label: 'Service' },
    { value: 'DYNAMIC', label: 'Dynamic' },
  ],

  DELIMITER_OPTIONS: [
    { value: 'comma', label: 'Comma' },
    { value: 'newline', label: 'New Line' },
    { value: 'custom', label: 'Custom' }
  ],

  RECURRING_INTERVAL: [
    { value: 'DAY', label: 'Day' },
    { value: 'WEEK', label: 'Week' },
    { value: 'MONTH', label: 'Month' },
    { value: 'YEAR', label: 'Year' }
  ],

  CUSTOM_TYPE: [
    { value: 'number', label: 'Number' },
    { value: 'text', label: 'Text' },
    { value: 'hidden', label: 'Hidden' },
    { value: 'largetextbox', label: 'Textbox' },
    { value: 'checkbox', label: 'Checkbox' },
    { value: 'select', label: 'Select' },
  ],

  DISCOUNT_TYPE: [
    { value: 'PERCENTAGE', label: 'Percentage' },
    { value: 'FIXED', label: 'Fixed' }
  ],

  EVENT_OPTIONS_NEW: {
    ORDER: [
      { value: 'order:created', label: 'order:created' },
      { value: 'order:updated', label: 'order:updated' },
      { value: 'order:partial', label: 'order:partial' },
      { value: 'order:paid', label: 'order:paid' },
      { value: 'order:paid:product', label: 'order:paid:product'},
      { value: 'order:cancelled', label: 'order:cancelled' },
      { value: 'order:disputed', label: 'order:disputed' },
      { value: 'order:cancelled:product', label: 'order:cancelled:product' },
      { value: 'order:disputed:product', label: 'order:disputed:product' },
      { value: 'order:created:product', label: 'order:created:product' },
      { value: 'order:partial:product', label: 'order:partial:product' },
      { value: 'order:updated:product', label: 'order:updated:product' },
    ],
    QUERY: [
      { value: 'query:created', label: 'query:created' },
      { value: 'query:replied', label: 'query:replied' }
    ],
    FEEDBACK: [
      { value: 'feedback:received', label: 'feedback:received' }
    ],
    PRODUCT: [
      { value: 'product:created', label: 'product:created' },
      { value: 'product:edited', label: 'product:edited' },
      { value: 'product:stock', label: 'product:stock' },
      { value: 'product:dynamic', label: 'product:dynamic' }
    ],
    SUBSCRIPTION: [
      { value: 'subscription:trial:started', label: 'subscription:trial:started' },
      { value: 'subscription:trial:ended', label: 'subscription:trial:ended' },

      { value: 'subscription:trial:started:product', label: 'subscription:trial:started:product' },
      { value: 'subscription:trial:ended:product', label: 'subscription:trial:ended:product' },
      { value: 'subscription:created:product', label: 'subscription:created:product' },
      { value: 'subscription:updated:product', label: 'subscription:updated:product' },
      { value: 'subscription:renewed:product', label: 'subscription:renewed:product' },

      { value: 'subscription:created', label: 'subscription:created' },
      { value: 'subscription:updated', label: 'subscription:updated' },
      { value: 'subscription:renewed', label: 'subscription:renewed' },
      { value: 'subscription:cancelled', label: 'subscription:cancelled' },
      { value: 'subscription:upcoming', label: 'subscription:upcoming' },

      { value: 'subscription:cancelled:product', label: 'subscription:cancelled:product' },
      { value: 'subscription:upcoming:product', label: 'subscription:upcoming:product' },
    ],
  },

  PAYPAL_CLIENT_ID: 'AYmeWr4qh9N01uf3DI8c1iR9sjYF7ojrb6M0vf6Nvh7xgyGvdUyBVgb3fZscNix2szXMI25oWc1GMeWx',
  PAYPAL_CLIENT_ID_SANDBOX: 'AYmeWr4qh9N01uf3DI8c1iR9sjYF7ojrb6M0vf6Nvh7xgyGvdUyBVgb3fZscNix2szXMI25oWc1GMeWx',

  STRIPE_APM_PARSE: {
    "promptpay": "PROMPTPAY",
    "afterpay_clearpay": "AFTERPAY_CLEARPAY",
    "alipay": "ALIPAY",
    "bancontact": "BANCONTACT",
    "au_becs_debit": "AU_BECS_DEBIT",
    "boleto": "BOLETO",
    "eps": "EPS",
    "fpx": "FPX",
    "giropay": "GIROPAY",
    "grabpay": "GRABPAY",
    "ideal": "IDEAL",
    "klarna": "KLARNA",
    "oxxo": "OXXO",
    "p24": "PRZELEWY24",
    "sepa_debit": "SEPA",
    "sofort": "SOFORT",
    "wechat_pay": "WECHAT_PAY",
    "cashapp": "CASH_APP",
  },

  DISCORD_INTEGRATION_BOT: 'https://discordapp.com/oauth2/authorize?client_id=1362470118864457990&permissions=469764114&scope=bot',
  DISCORD_INTEGRATION_OAUTH: 'https://discord.com/api/oauth2/authorize?client_id=1362470118864457990&redirect_uri=https%3A%2F%2Foauth.paylix.gg%2Fdiscord&response_type=code&scope=identify%20guilds%20guilds.join%20guilds.members.read%20gdm.join',

  DISCORD_CUSTOMER_INTEGRATION_OAUTH: 'https://discord.com/api/oauth2/authorize?client_id=1362470118864457990&redirect_uri=https%3A%2F%2Fembed.paylix.gg&response_type=code&scope=identify%20guilds%20guilds.join%20guilds.members.read%20gdm.join',
  DISCORD_CUSTOMER_INTEGRATION_OAUTH_LOCAL: 'https://discord.com/api/oauth2/authorize?client_id=1362470118864457990&redirect_uri=http%3A%2F%2Fembed.paylix.gg&response_type=code&scope=identify%20guilds%20guilds.join%20guilds.members.read%20gdm.join',
  DISCORD_CUSTOMER_INTEGRATION_OAUTH_STAGING: 'https://discord.com/api/oauth2/authorize?client_id=1362470118864457990&redirect_uri=https%3A%2F%2Fembed.paylixecommerce-staging.io&response_type=code&scope=identify%20guilds%20guilds.join%20guilds.members.read%20gdm.join',
  DISCORD_CUSTOMER_INTEGRATION_OAUTH_WALLET: 'https://discord.com/api/oauth2/authorize?client_id=1362470118864457990&redirect_uri=https%3A%2F%2Fembed.paylixecommerce-crispy.io&response_type=code&scope=identify%20guilds%20guilds.join%20guilds.members.read%20gdm.join',

  DISCORD_CUSTOMER_INTEGRATION_PAY_OAUTH: 'https://discord.com/api/oauth2/authorize?client_id=1362470118864457990&redirect_uri=https%3A%2F%2Fpay.paylix.gg&response_type=code&scope=identify%20guilds%20guilds.join%20guilds.members.read%20gdm.join',
  DISCORD_CUSTOMER_INTEGRATION_PAY_OAUTH_LOCAL: 'https://discord.com/api/oauth2/authorize?client_id=1362470118864457990&redirect_uri=http%3A%2F%2Fpay.local-test-paylixecommerce.com:3000&response_type=code&scope=identify%20guilds%20guilds.join%20guilds.members.read%20gdm.join',
  DISCORD_CUSTOMER_INTEGRATION_PAY_OAUTH_STAGING: 'https://discord.com/api/oauth2/authorize?client_id=1362470118864457990&redirect_uri=https%3A%2F%2Fpay.paylixecommerce-staging.io&response_type=code&scope=identify%20guilds%20guilds.join%20guilds.members.read%20gdm.join',
  DISCORD_CUSTOMER_INTEGRATION_PAY_OAUTH_WALLET: 'https://discord.com/api/oauth2/authorize?client_id=1362470118864457990&redirect_uri=https%3A%2F%2Fpay.paylixecommerce-crispy.io&response_type=code&scope=identify%20guilds%20guilds.join%20guilds.members.read%20gdm.join',


  TELEGRAM: {
    BOT_ID: 6792778065,
    BOT_NAME: 'paylixecommerceMerchantBot',
    INTEGRATION_OAUTH_URL: 'https://telegram-oauth.paylix.gg',
  },

}
